module.exports = __webpack_public_path__ + "img/wb_so.56ec294c.jpg";